import PropTypes from 'prop-types';

export const ImageShape = PropTypes.shape({
  alt: PropTypes.string,
  image: PropTypes.shape({
    asset: PropTypes.shape({
      url: PropTypes.string,
    }),
    _id: PropTypes.string,
  }),
});

export const PostShape = PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  videoPost: PropTypes.bool,
  videoLink: PropTypes.string,
  sleuthTvLive: PropTypes.bool,
  videoAirDate: PropTypes.string,
  publishedAt: PropTypes.string,
  author: ImageShape,
  slug: PropTypes.string,
  featureImage: ImageShape,
  path: PropTypes.string,
  category: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string,
  }),
  subcategory: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string,
  }),
  body: PropTypes.any,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
    })
  ),
  related: PropTypes.array,
});

export const SubCategoryShape = PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  path: PropTypes.string,
  posts: PropTypes.arrayOf(PostShape),
  slug: PropTypes.string,
});

export const CategoryShape = PropTypes.shape({
  title: PropTypes.string,
  description: PropTypes.string,
  featuredPost: PostShape,
  subcategories: PropTypes.arrayOf(SubCategoryShape),
});
